import { IHttpApi } from '@cian/http-api/shared';
import { ResponseError } from '../errors/ResponseError';
import {
  fetchAjaxFeedback,
  IAjaxFeedbackRequest,
  IAjaxFeedbackResponse,
  IAjaxFeedbackResponse200,
  IAjaxFeedbackResponse400,
  IAjaxFeedbackResponseError,
} from '../repositories/monolith-python/unversioned/ajax-feedback';
import { isResponseContainsKey } from './helpers';

export async function sendFeedback(httpApi: IHttpApi, parameters: IAjaxFeedbackRequest, subdomain?: string) {
  const { response } = await fetchAjaxFeedback<IAjaxFeedbackResponse200, IAjaxFeedbackResponse400>({
    httpApi,
    parameters,
    config: {
      requestConfig: {
        headers: [['Content-Type', 'application/json']],
      },
      subdomain: subdomain || 'www',
    },
  });

  if (isResponseContainsKey<IAjaxFeedbackResponseError, IAjaxFeedbackResponse>(response, 'errors')) {
    throw new ResponseError({
      domain: 'sendFeedback',
      message: response.message,
    });
  }

  return response;
}
